import React, {useState, useEffect} from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import CssBaseline from '@mui/material/CssBaseline';
import Divider from '@mui/material/Divider';
import Drawer from '@mui/material/Drawer';
import IconButton from '@mui/material/IconButton';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import MenuIcon from '@mui/icons-material/Menu';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import { Link, useLocation } from 'react-router-dom';
import { useSelector, useDispatch } from "react-redux";
import HomeIcon from '@mui/icons-material/Home';
import DashboardIcon from '@mui/icons-material/Dashboard';
import CarIcon from '@mui/icons-material/DirectionsCar';
import ExitIcon from '@mui/icons-material/ExitToApp';
import OfferIcon from '@mui/icons-material/LocalOffer';
import NotifyIcon from '@mui/icons-material/NotificationsActive';
import { api } from 'common';
import { colors } from '../components/Theme/WebTheme';
import { useTranslation } from "react-i18next";
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import ContactPhoneIcon from '@mui/icons-material/ContactPhone';
import ViewListIcon from '@mui/icons-material/ViewList';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import EmojiPeopleIcon from '@mui/icons-material/EmojiPeople';
import AssessmentIcon from '@mui/icons-material/Assessment';
import MoneyIcon from '@mui/icons-material/Money';
import PhoneIphoneIcon from '@mui/icons-material/PhoneIphone';
import {calcEst, showEst, optionsRequired} from '../common/sharedFunctions';
import SosIcon from '@mui/icons-material/Sos';
import {MAIN_COLOR, SECONDORY_COLOR, FONT_FAMILY} from "../common/sharedFunctions"
import AnnouncementOutlinedIcon from '@mui/icons-material/AnnouncementOutlined';
import SettingsIcon from '@mui/icons-material/Settings';
import PaymentIcon from '@mui/icons-material/Payment';
import Avatar from '@mui/material/Avatar';
import Badge from '@mui/material/Badge';
import Tooltip from '@mui/material/Tooltip';
import CloseIcon from '@mui/icons-material/Close';

// Yeni modern renk şeması (Sarı Tema)
const modernColors = {
  primary: '#FFC107', // Ana Sarı (Amber 500)
  primaryLight: '#FFD54F', // Açık Sarı (Amber 300)
  primaryDark: '#FFA000', // Koyu Sarı (Amber 700)
  secondary: '#10B981', // Yeşil (Şimdilik aynı kalabilir, gerekirse değiştirilir)
  secondaryLight: '#34D399', // Açık yeşil
  background: '#F9FAFB', // Açık gri arka plan
  surface: '#FFFFFF', // Yüzey rengi
  accent: '#4F46E5', // Vurgu rengi olarak eski mor kullanılabilir veya değiştirilebilir
  textPrimary: '#1F2937', // Koyu metin (Sarı ile daha iyi kontrast için hafif ayar)
  textSecondary: '#4B5563', // İkincil metin (Sarı ile daha iyi kontrast için hafif ayar)
  divider: '#E5E7EB', // Ayırıcı çizgi rengi
  hover: '#FFFBEB', // Hover durumu (Çok açık sarı)
  active: '#FFF8E1', // Aktif öğe rengi (Amber 50)
  error: '#EF4444', // Hata rengi
  info: '#3B82F6', // Bilgi rengi
  black: '#000000',
  white: '#FFFFFF',
}

const drawerWidth = 280;

export default function ResponsiveDrawer(props) {
  const { t, i18n  } = useTranslation();
  const isRTL = i18n.dir();
  const { window } = props;
  const [mobileOpen, setMobileOpen] = React.useState(false);
  const location = useLocation();
  const {
    signOff
  } = api;
  const auth = useSelector(state => state.auth);
  const settings = useSelector(state => state.settingsdata.settings);
  const dispatch = useDispatch();

  const LogOut = () => {
    dispatch(signOff());
  };

  const [role, setRole] = useState(null);

  useEffect(() => {
    if(auth.profile && auth.profile.usertype){
      setRole(auth.profile.usertype);
    }
  }, [auth.profile]);

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };
  const handleDrawer = () => {
    setMobileOpen(false);
  };

  const menuItems = [
    {name: t('home'), url: '/', icon: <HomeIcon/>, access: ['admin','fleetadmin','driver','customer']},
    {name: t('dashboard_text'), url: '/dashboard', icon: <DashboardIcon/>, access: ['admin','fleetadmin']},
    {name: t('booking_history'), url: '/bookings', icon: <ViewListIcon/>, access: ['admin','fleetadmin','driver','customer']},
    {name: t('addbookinglable'), url: '/addbookings', icon: <ContactPhoneIcon/>, access: calcEst && !showEst && !optionsRequired ? ['customer'] : ['admin','fleetadmin','customer']},
    {name: t('user'), url: '/users/0', icon: <EmojiPeopleIcon/>, access: ['admin','fleetadmin']},
    {name: t('car_type'), url: '/cartypes', icon: <CarIcon/>, access: ['admin']},
    {name: t('cars'), url: '/cars', icon: <CarIcon/>, access: ['admin','fleetadmin','driver']},
    {name: t('withdraws_web'), url: '/withdraws', icon: <MoneyIcon/>, access: ['admin']},
    {name: t('add_to_wallet'), url: '/addtowallet', icon: <AccountBalanceWalletIcon/>, access: ['admin']},
    {name: t('report'), url: '/allreports', icon: <AssessmentIcon/>, access: ['admin','fleetadmin']},
    {name: t('promo'), url: '/promos', icon: <OfferIcon/>, access: ['admin']},
    {name: t('push_notifications'), url: '/notifications', icon: <NotifyIcon/>, access: ['admin']},
    {name: t('sos'), url: '/sos', icon: <SosIcon/>, access: ['admin']},
    {name: t('complain'), url: '/complain', icon: <AnnouncementOutlinedIcon/>, access: ['admin']},
    {name: t('my_wallet_tile'), url: '/userwallet', icon: <AccountBalanceWalletIcon/>, access: ['driver','customer','fleetadmin']},
    {name: t('settings_title'), url: '/settings', icon: <SettingsIcon/>, access: ['admin']},
    {name: t('payment_settings'), url: '/paymentsettings', icon: <PaymentIcon/>, access: ['admin']},
    {name: t('profile'), url: '/profile', icon: <AccountCircleIcon/>, access: ['admin','fleetadmin','driver','customer']},
    {name: t('logout'), url: 'logout', icon: <ExitIcon/>, access: ['admin','fleetadmin','driver','customer']}
  ];

  // Drawer içeriği (stil kodları yeni modernColors'ı kullanacak)
  const drawer = (
    <Box sx={{
      height: '100%', 
      display: 'flex', 
      flexDirection: 'column',
      background: `linear-gradient(180deg, ${modernColors.surface} 0%, ${modernColors.background} 100%)`,
    }}>
      {/* Başlık Bölümü */}
      <Box sx={{ 
        display: 'flex', 
        flexDirection: 'column', 
        alignItems: 'center',
        position: 'relative',
        padding: '32px 16px 24px',
        backgroundColor: modernColors.primary, // Yeni sarı
        backgroundImage: `linear-gradient(135deg, ${modernColors.primary} 0%, ${modernColors.primaryDark} 100%)`, // Sarı gradyan
        borderBottom: '1px solid rgba(0, 0, 0, 0.1)', // Siyah transparan border sarı ile daha iyi görünebilir
        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.08)'
      }}>
        {/* Mobil kapatma butonu */}
        {mobileOpen && (
          <IconButton 
            onClick={handleDrawerToggle}
            sx={{
              position: 'absolute',
              top: 8,
              right: 8,
              color: 'rgba(0,0,0,0.6)', // Sarı arka planda siyah daha iyi
              '&:hover': {
                backgroundColor: 'rgba(0,0,0,0.08)',
                color: modernColors.black
              }
            }}
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        )}

        
        {/* Uygulama İsmi */}
        <Typography 
          variant="h6" 
          sx={{ 
            fontWeight: 700, 
            fontFamily: FONT_FAMILY,
            color: modernColors.textPrimary, // Sarı arka planda koyu metin
            letterSpacing: '0.5px',
            // textShadow: '0 1px 2px rgba(255, 255, 255, 0.3)' // Açık gölge belki?
          }}
        >
          {settings && settings.appName ? settings.appName : ''}
        </Typography>
        
      
      </Box>

      {/* Menü Bölümü */}
      <Box sx={{ 
        overflow: 'auto', 
        flex: 1,
        py: 2,
        px: 1.5,
        '&::-webkit-scrollbar': {
          width: '6px'
        },
        '&::-webkit-scrollbar-thumb': {
          backgroundColor: 'rgba(255, 160, 0, 0.4)', // Koyu sarı transparan
          borderRadius: '6px',
          '&:hover': {
            backgroundColor: 'rgba(255, 160, 0, 0.6)' // Koyu sarı daha belirgin
          }
        },
        '&::-webkit-scrollbar-track': {
          backgroundColor: 'transparent'
        }
      }}>
        {role ? (
          <List sx={{ py: 0 }}>
            {menuItems.map((item, index) => {
              if (item.access.includes(role)) {
                const isSelected = location.pathname === item.url;
                
                return (
                  <React.Fragment key={`item-${index}`}>
                    <Tooltip 
                      title={item.name} 
                      placement="right"
                      arrow
                    >
                      <ListItem disablePadding sx={{ mb: 0.75 }}>
                        <ListItemButton
                          component={Link}
                          to={item.url === 'logout' ? null : item.url}
                          onClick={item.url === 'logout' ? LogOut : handleDrawer}
                          selected={isSelected}
                          sx={{
                            py: 1.25,
                            px: 2,
                            borderRadius: '10px',
                            position: 'relative',
                            transition: 'all 0.2s ease',
                            backgroundColor: isSelected ? modernColors.active : 'transparent', // Aktif sarı
                            color: isSelected ? modernColors.primaryDark : modernColors.textSecondary, // Koyu sarı veya gri
                            '&:hover': {
                              backgroundColor: isSelected ? modernColors.active : modernColors.hover, // Açık sarılar
                              transform: 'translateY(-1px)',
                              boxShadow: isSelected ? `0 4px 12px ${modernColors.primary}30` : 'none' // Sarı gölge
                            },
                            ...(isSelected && {
                              fontWeight: 600,
                              '&::before': {
                                content: '""',
                                position: 'absolute',
                                left: 0,
                                top: '50%',
                                transform: 'translateY(-50%)',
                                height: '60%',
                                width: '4px',
                                backgroundColor: modernColors.primary, // Ana sarı
                                borderRadius: '0 4px 4px 0'
                              }
                            })
                          }}
                        >
                          <ListItemIcon 
                            sx={{ 
                              color: isSelected ? modernColors.primaryDark : modernColors.textSecondary, // Koyu sarı veya gri
                              minWidth: '42px',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              '& .MuiSvgIcon-root': {
                                fontSize: '1.3rem',
                                transition: 'all 0.2s ease',
                                ...(isSelected && {
                                  transform: 'scale(1.1)',
                                  filter: `drop-shadow(0 2px 4px ${modernColors.primary}50)` // Sarı gölge
                                })
                              }
                            }}
                          >
                            {item.icon}
                          </ListItemIcon>
                          <ListItemText
                            primary={
                              <Typography 
                                sx={{ 
                                  color: isSelected ? modernColors.primaryDark : modernColors.textPrimary, // Koyu sarı veya koyu metin
                                  fontSize: '0.9rem',
                                  fontWeight: isSelected ? 600 : 500,
                                  fontFamily: FONT_FAMILY,
                                  transition: 'all 0.2s ease'
                                }}
                              >
                                {item.name}
                              </Typography>
                            }
                          />
                        </ListItemButton>
                      </ListItem>
                    </Tooltip>
                  </React.Fragment>
                );
              }
              return null;
            })}
          </List>
        ) : null}
      </Box>
      
      {/* Footer Bölümü */}
      <Box sx={{ 
        padding: '16px', 
        textAlign: 'center',
        borderTop: `1px solid ${modernColors.divider}`
      }}>
        <Typography variant="caption" sx={{ color: modernColors.textSecondary, fontFamily: FONT_FAMILY }}>
          © {new Date().getFullYear()} {settings && settings.appName ? settings.appName : ''}
        </Typography>
      </Box>
    </Box>
  );

  const container = window !== undefined ? () => window().document.body : undefined;

  return (
    <Box sx={{ display: 'flex', direction: isRTL === 'rtl' ? 'rtl' : 'ltr' }}>
      <CssBaseline />
      
      {/* AppBar */}
      <AppBar
        position="fixed"
        elevation={0}
        sx={{
          width: { sm: `calc(100% - ${drawerWidth}px)` },
          ml: { sm: isRTL === 'rtl' ? 0 : `${drawerWidth}px` },
          mr: { sm: isRTL === 'rtl' ? `${drawerWidth}px` : 0 },
          backgroundColor: modernColors.white,
          color: modernColors.textPrimary,
          borderBottom: `1px solid ${modernColors.divider}`,
          backdropFilter: 'blur(8px)',
          boxShadow: '0 4px 20px rgba(0, 0, 0, 0.04)'
        }}
      >
        <Toolbar sx={{ display: 'flex', justifyContent: 'space-between' }}>
          {/* Hamburger Menu */}
          <IconButton
            aria-label="open drawer"
            edge="start"
            onClick={handleDrawerToggle}
            sx={{ 
              display: { sm: 'none' },
              color: modernColors.primary, // Ana sarı
              backgroundColor: `rgba(255, 193, 7, 0.08)`, // Sarı transparan
              '&:hover': {
                backgroundColor: `rgba(255, 193, 7, 0.12)` // Sarı transparan hover
              }
            }}
          >
            <MenuIcon />
          </IconButton>
          
          {/* Başlık */}
          <Typography 
            variant="h6" 
            noWrap 
            component="div" 
            sx={{ 
              fontWeight: 700,
              fontSize: '1.125rem',
              fontFamily: FONT_FAMILY,
              color: modernColors.primaryDark, // Koyu sarı
              display: { xs: 'none', sm: 'block' }
            }}
          >
            {settings && settings.appName ? settings.appName : ''}
          </Typography>
          
          {/* Profil ve Kullanıcı Bilgisi */}
          {auth.profile && (
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <Typography 
                variant="subtitle2" 
                sx={{ 
                  fontFamily: FONT_FAMILY, 
                  fontWeight: 500, 
                  color: modernColors.textSecondary 
                }}
              >
                {auth.profile.firstName} {auth.profile.lastName}
              </Typography>
              <Avatar 
                src={auth.profile.profile_image} 
                alt={auth.profile.firstName}
                sx={{ 
                  width: 36, 
                  height: 36,
                  border: `2px solid ${modernColors.divider}`
                }}
              />
            </Box>
          )}
        </Toolbar>
      </AppBar>
      
      {/* Drawer */}
      <Box
        component="nav"
        sx={{ width: { sm: drawerWidth }, flexShrink: { sm: 0 } }}
        aria-label="drawer"
      >
        {/* Mobil Drawer */}
        <Drawer
          container={container}
          variant="temporary"
          anchor={isRTL === 'rtl' ? 'right' : 'left'}
          open={mobileOpen}
          onClose={handleDrawerToggle}
          ModalProps={{
            keepMounted: true
          }}
          sx={{
            display: { xs: 'block', sm: 'none' },
            '& .MuiDrawer-paper': { 
              boxSizing: 'border-box', 
              width: drawerWidth,
              boxShadow: '0 8px 24px rgba(0, 0, 0, 0.12)'
            },
            direction: isRTL === 'rtl' ? 'rtl' : 'ltr'
          }}
        >
          {drawer}
        </Drawer>
        
        {/* Masaüstü Drawer */}
        <Drawer
          variant="permanent"
          anchor={isRTL === 'rtl' ? 'right' : 'left'}
          sx={{
            display: { xs: 'none', sm: 'block' },
            '& .MuiDrawer-paper': { 
              boxSizing: 'border-box', 
              width: drawerWidth,
              boxShadow: '4px 0 24px rgba(0, 0, 0, 0.06)',
              border: 'none'
            },
            direction: isRTL === 'rtl' ? 'rtl' : 'ltr'
          }}
          open
        >
          {drawer}
        </Drawer>
      </Box>
      
      {/* Ana İçerik */}
      <Box
        component="main"
        sx={{ 
          flexGrow: 1, 
          p: 3, 
          width: { sm: `calc(100% - ${drawerWidth}px)` },
          backgroundColor: modernColors.background,
          minHeight: '100vh',
          background: `linear-gradient(135deg, ${modernColors.background} 0%, ${modernColors.surface} 100%)`
        }}
      >
        <Toolbar />
        {props.children}
      </Box>
    </Box>
  );
}
